// Backend takes integer value 1-4 for sales_experience fields.
// Frontend is responsible for mapping that to the correct string for the UI.
export const SALES_EXPERIENCE_OPTIONS = [
  { value: 0, label: "Less than a year" },
  { value: 1, label: "1-2 years" },
  { value: 2, label: "3-5 years" },
  { value: 3, label: "6-9 years" },
  { value: 4, label: "10+ years" },
];
